import ContentLoader from 'react-content-loader';

export const AnglerCatchesViewLoader = () => (
  <div className="mb-8 grid gap-4 sm:grid-cols-2">
    <ContentLoader uniqueKey="AnglerCatchesView-key-1" className="size-full">
      <rect x="0" y="0" rx="5" ry="5" width="220" height="220" style={{ width: '100%' }} />
    </ContentLoader>
    <ContentLoader uniqueKey="AnglerCatchesView-key-2" className="size-full">
      <rect x="0" y="0" rx="5" ry="5" width="220" height="220" style={{ width: '100%' }} />
    </ContentLoader>
    <ContentLoader uniqueKey="AnglerCatchesView-key-3" className="size-full">
      <rect x="0" y="0" rx="5" ry="5" width="220" height="220" style={{ width: '100%' }} />
    </ContentLoader>
    <ContentLoader uniqueKey="AnglerCatchesView-key-4" className="size-full">
      <rect x="0" y="0" rx="5" ry="5" width="220" height="220" style={{ width: '100%' }} />
    </ContentLoader>
    <ContentLoader uniqueKey="AnglerCatchesView-key-5" className="size-full">
      <rect x="0" y="0" rx="5" ry="5" width="220" height="220" style={{ width: '100%' }} />
    </ContentLoader>
    <ContentLoader uniqueKey="AnglerCatchesView-key-6" className="size-full">
      <rect x="0" y="0" rx="5" ry="5" width="220" height="220" style={{ width: '100%' }} />
    </ContentLoader>
  </div>
);
